import { createWebHistory, createRouter } from "vue-router";

import unregisterForm from "edr-unregister-plugin"
import redirect from "edr-redirect-plugin"


const routes = [
  {
    path: "/",
    name: "Unregister",
    component: unregisterForm,
  },
  {
    path: "/redirect",
    name: "Redirect",
    component: redirect,
  },
  {
    path: "/unregister",
    name: "Unregister",
    component: unregisterForm,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;